<template lang="pug">
  .b-ellipsis-menu(:class="{ light }" v-if="items.length")
    Icon._icon(name="more" @click.native="isOpened = !isOpened" pointer :class="{ vertical, hidden, isOpened }")
    CommonDropdown._dropdown(:class="{ up, left }" :center="!left" :items="items" :isOpened="isOpened" @click.native="isOpened = false")
</template>

<script>
import CommonDropdown from '@/components/CommonDropdown.vue';

export default {
  name: 'EllipsisMenu',
  components: { CommonDropdown },
  props: {
    items: Array,
    light: Boolean,
    vertical: Boolean,
    hidden: Boolean,
    // Открывать меню вверх, а не вниз. Направление задаёт родитель: только он
    // знает, есть ли под строкой скролл-контейнер и сколько до его нижней границы
    up: Boolean,
    // Раскрывать меню влево от кнопки, а не по центру. Тоже решение родителя:
    // нужно там, где кнопка стоит у правого края узкого контейнера и
    // центрированное меню вылезало бы за его границу
    left: Boolean,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpened = false;
      }
    },
  },
  // Слушаем в capture-фазе: BasePopup глушит всплытие клика на своём
  // ._spacer, поэтому до document клик изнутри попапа доходит только сверху
  // вниз — без этого меню внутри любого попапа не закрывалось бы по клику мимо
  mounted() {
    document.addEventListener('click', this.close, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close, true);
  },
};
</script>

<style scoped lang="scss">
.ellipsis-menu {
  position: relative;
  fill: var(--color-light-dark);

  &:before {
    content: '';
    display: block;
    position: absolute;
    z-index: 1;
    top:-8px;
    left: -8px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    transition: background-color 0.1s;
  }

  &:not(.light):hover {
    cursor: pointer;

    &:before {
      background-color: var(--color-super-light);
    }
  }

  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    position: relative;
    z-index: 2;

    &.vertical {
      transform: rotate(90deg);
    }

    &.hidden {
      opacity: 0;

      &.isOpened, &:hover {
        opacity: 1;
      }
    }
  }
  &__dropdown {
    top: 30px;
    // По умолчанию меню центрируется относительно кнопки. Сам горизонтальный
    // сдвиг ставит DropdownShifter инлайновым transform (проп center), здесь
    // только точка отсчёта
    right: calc(50% + 5px);

    &:before {
      right: 0;
      left: calc(50% + 5px);
      transform: translateX(-50%);
    }

    // Раскрытие влево от кнопки — см. проп left
    &.left {
      right: 0;

      &:before {
        right: 4px;
        left: auto;
        transform: none;
      }
    }

    &.up {
      top: auto;
      bottom: 30px;

      &:before {
        top: auto;
        bottom: -16px;
        transform: rotate(180deg);
      }
    }
  }

  &.light &__icon {
    fill: #D3EAFF;
  }
}
</style>
